<template>
  <v-container fluid>
    <v-data-table
      :headers="dessertHeaders"
      :items="others"
      :search="search"
      item-key="id_other"

      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Other Data</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            solo
            dense
            append-icon="mdi-magnify"
            label="Search Other Data"
            class="mr-3 white"
            outlined
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template #[`item.rate`]="{ item }">
        Rp. {{ Number(item.rate).toLocaleString() }}
      </template>
      <template #[`item.actions`]="{ item }">
        <v-btn
          color="primary"
          @click="UseService(item)"
        >
          Use Service
          <v-icon>{{ icons.mdiPlus }}</v-icon>
        </v-btn>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="initialize"
        >
          Reset
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import axios from 'axios'
import {
  mdiPencil,
  mdiTrashCan,
  mdiPlus,
  mdiClose,
  mdiCalendar,
} from '@mdi/js'

export default {

  data() {
    return {
      icons: {
        mdiPencil,
        mdiTrashCan,
        mdiPlus,
        mdiClose,
        mdiCalendar,
      },
      modal: false,
      modal5: false,
      expanded: [],
      singleExpand: true,
      dialog: false,
      editedIndex: -1,
      search: '',
      form: {
        other_name: '',
        id_other: '',
        rate: '',
        note: '',
      },
      service: [],
      dessertHeaders: [
        { text: 'Other Name', value: 'other_name' },
        { text: 'Rate', value: 'rate' },
        { text: 'Category', value: 'category' },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
          width: 200,
        },
      ],

      others: [],

    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Add New Other' : 'Edit Other'
    },
    TittleButton() {
      return this.editedIndex === -1 ? 'Save Other' : 'Update Other'
    },
  },

  mounted() {
    this.initialize()
  },
  methods: {
    UseService(item) {
      this.$root.$emit('BuatTravelCost', item, 'Other')
    },
    CekDialog() {
      this.form = {
        other_name: '',
        id_other: '',
        rate: '',
        note: '',
      }
      this.dialog = false
    },

    editItem(item) {
      this.editedIndex = this.others.indexOf(item)
      this.form = item
      this.dialog = true
    },
    deleteItem(item) {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/DeleteAgent', item).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.initialize()
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    initialize() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.get('auth/Other').then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.others = response.data.data
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    Save() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/SaveOther', this.form).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.initialize()
        this.dialog = false
        this.CekDialog()
        this.editedIndex = -1
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
  },
}
</script>
